import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { size, weight, lineHeight } from "@clockwise/web-commons/src/styles/type.styles";
import { baseBody } from "../SuggestionBody.styles";

export { eventDateRow, metaInfo, eventDateIcon, eventDate } from "../SuggestionBody.styles";

export const container: CSSProperties = {
  ...baseBody,
  width: "100%",
};

export const description = {
  body: {
    margin: "15px 0 10px 0",
    fontSize: size.md,
    lineHeight: lineHeight.std,
    color: greys.slate,
  } as CSSProperties,
  cost: {
    color: colors.red.bright,
    fontWeight: weight.bold,
  } as CSSProperties,
};

export const tooltipIcon: CSSProperties = {
  color: greys.blueGrey,
};
